import {
	SHOPDATA_LOADING,
	SHOPDATA_SAVING_FAILED,
	SHOPDATA_SAVING_SUCCESSED,
} from "../actions/types";
const initialState = {
	data: {},
	saved: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case SHOPDATA_LOADING:
			return {
				...state,

				saved: false,
			};
		case SHOPDATA_SAVING_SUCCESSED:
			return {
				...state,
				data: action.payload,
				saved: true,
			};
		case SHOPDATA_SAVING_FAILED:
			return {
				...state,
				saved: false,
			};
		default:
			return state;
	}
}
